// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast_container_container__DzpKk {
    width: 300px;
    height: 60px;
    background-color: red;
    position: absolute;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0 1rem 1rem 0;
    padding: 0 1rem;
    z-index: 998;
    text-align: left;
    font-weight: 500;
}

.toast_container_progressBar__Z-X37 {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 999;
    height: 4px;
    background-color: #ccc;
    width: 100%;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}

.toast_container_closeButton__mhtfs {
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 0.3rem;
    margin-right: 0.5rem;
    cursor: pointer;
    z-index: 999;
}

.toast_container_toastBottomRight__H1rBr {
    bottom: 0;
    right: 0;
}

.toast_container_toastSuccess__8WCTF {
    background-color: #01B20B;
    color: #ffffff;
}

.toast_container_toastWarning__VlN2a {
    background-color: #EDBA0F;
    color: #ffffff;
}

.toast_container_toastError__lC3ns {
    background-color: #E23E31;
    color: #ffffff;
}

.toast_container_toastInfo__zybwG {
    background-color: #2C8BD1;
    color: #ffffff;
}

.toast_container_toastDark__erRid {
    background-color: #110F10;
    color: #ffffff;
}

.toast_container_progressBarSuccess__kLDr7 {
    background-color: #A8E8AD;
}

.toast_container_progressBarError__5Ohz7 {
    background-color: #E4C9C3;
}

.toast_container_progressBarWarning__fxHi3 {
    background-color: #F8E9B0;
}

.toast_container_progressBarInfo__Le1Z0 {
    background-color: #B6DCF3;
}

.toast_container_progressBarDarkSuccess__HHj5I {
    background-color: #01B20B;
}

.toast_container_progressBarDarkError__\\+hzQ6 {
    background-color: #E23E31;
}`, "",{"version":3,"sources":["webpack://./src/components/ajonjolib/toasts/toast/toast_container.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".container {\n    width: 300px;\n    height: 60px;\n    background-color: red;\n    position: absolute;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin: 0 1rem 1rem 0;\n    padding: 0 1rem;\n    z-index: 998;\n    text-align: left;\n    font-weight: 500;\n}\n\n.progressBar {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    z-index: 999;\n    height: 4px;\n    background-color: #ccc;\n    width: 100%;\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px;\n}\n\n.closeButton {\n    position: absolute;\n    top: 0;\n    right: 0;\n    margin-top: 0.3rem;\n    margin-right: 0.5rem;\n    cursor: pointer;\n    z-index: 999;\n}\n\n.toastBottomRight {\n    bottom: 0;\n    right: 0;\n}\n\n.toastSuccess {\n    background-color: #01B20B;\n    color: #ffffff;\n}\n\n.toastWarning {\n    background-color: #EDBA0F;\n    color: #ffffff;\n}\n\n.toastError {\n    background-color: #E23E31;\n    color: #ffffff;\n}\n\n.toastInfo {\n    background-color: #2C8BD1;\n    color: #ffffff;\n}\n\n.toastDark {\n    background-color: #110F10;\n    color: #ffffff;\n}\n\n.progressBarSuccess {\n    background-color: #A8E8AD;\n}\n\n.progressBarError {\n    background-color: #E4C9C3;\n}\n\n.progressBarWarning {\n    background-color: #F8E9B0;\n}\n\n.progressBarInfo {\n    background-color: #B6DCF3;\n}\n\n.progressBarDarkSuccess {\n    background-color: #01B20B;\n}\n\n.progressBarDarkError {\n    background-color: #E23E31;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `toast_container_container__DzpKk`,
	"progressBar": `toast_container_progressBar__Z-X37`,
	"closeButton": `toast_container_closeButton__mhtfs`,
	"toastBottomRight": `toast_container_toastBottomRight__H1rBr`,
	"toastSuccess": `toast_container_toastSuccess__8WCTF`,
	"toastWarning": `toast_container_toastWarning__VlN2a`,
	"toastError": `toast_container_toastError__lC3ns`,
	"toastInfo": `toast_container_toastInfo__zybwG`,
	"toastDark": `toast_container_toastDark__erRid`,
	"progressBarSuccess": `toast_container_progressBarSuccess__kLDr7`,
	"progressBarError": `toast_container_progressBarError__5Ohz7`,
	"progressBarWarning": `toast_container_progressBarWarning__fxHi3`,
	"progressBarInfo": `toast_container_progressBarInfo__Le1Z0`,
	"progressBarDarkSuccess": `toast_container_progressBarDarkSuccess__HHj5I`,
	"progressBarDarkError": `toast_container_progressBarDarkError__+hzQ6`
};
export default ___CSS_LOADER_EXPORT___;
